/**
 * Registers TypeScript declaration files with Monaco's language service
 * so the schema editor has type information for the DSL helpers available in
 * the editor (z.* from Zod and defineRuntimeSchema).
 *
 * The declarations are shipped as plain .txt files and imported as raw strings
 * via Vite's `?raw` suffix, which avoids bundling them as executable code.
 *
 * This function is passed as the `beforeMount` prop on the <Editor> component,
 * so it runs before each editor instance is created. We guard against
 * re-registering using Monaco's getExtraLibs() registry.
 */

import type { Monaco } from '@monaco-editor/react';
import schemaEditorTypes from './schema-editor-types.d.ts.txt?raw';
import zodMonacoTypes from '../../../generated/zod-monaco.generated.d.ts.txt?raw';

const schemaEditorTypeLibraries = [
  {
    content: zodMonacoTypes,
    path: 'file:///zod-monaco.generated.d.ts',
  },
  {
    content: schemaEditorTypes,
    path: 'file:///schema-editor-types.d.ts',
  },
] as const;

export const registerSchemaEditorMonacoLibs = (monaco: Monaco) => {
  const registered =
    monaco.languages.typescript.typescriptDefaults.getExtraLibs();

  for (const library of schemaEditorTypeLibraries) {
    if (!registered[library.path]) {
      monaco.languages.typescript.typescriptDefaults.addExtraLib(
        library.content,
        library.path,
      );
    }
  }
};
